import {
    Box,
    Center,
    SimpleGrid,
    Link,
    Text,
    Container,
    Button,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue,
    Select
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { merge, tap } from "rxjs";
import { MUTANTS_ADDRESS, ULTIMATE_ADDRESS } from "../config";
import Web3Service from "../core/web3.service";

import BackgroundImage from "../images/background-nft.webp"
import NFTItemView from "./NFTItemView";

interface GalleryViewProps { }

const GalleryView: React.FC<GalleryViewProps> = (props) => {
    const web3Service = Web3Service.shared();

    const [collectionOption, setCollectionOption] = useState<number>(0);
    const [account, setAccount] = useState<string | undefined>(undefined);
    const [tokens, setTokens] = useState<number[]>([]);

    useEffect(() => {
        const account$ = web3Service.account$.pipe(
            tap((account) => {
                setAccount(account);
            })
        );

        const tokens$ = web3Service.tokens$.pipe(
            tap((tokens) => {
                setTokens(tokens);
            })
        );

        const subscription = merge(
            tokens$,
            account$
        ).subscribe();

        return () => {
            subscription.unsubscribe();
        };
    }, [account]);

    useEffect(() => {
        let collectionAddress: string
        switch (collectionOption) {
            case 1:
                collectionAddress = "0x44aa4cB2efF7167A306449EDe9b550e57Ca33036"
                break;
            case 2:
                collectionAddress = "0x28238122BECBE1D727F2D23631eD83d6cbe833Bc"
                break;
            case 3:
                collectionAddress = MUTANTS_ADDRESS
                break;
            case 4:
                collectionAddress = ULTIMATE_ADDRESS
                break
            default:
                collectionAddress = "0x51eaf8c081Cca683A5542c438f9429CE46D238e4"
                break;
        }
        web3Service.getUserTokens(collectionAddress);
    }, [account, collectionOption]);

    let imagesBaseUri: string
    switch (collectionOption) {
        case 1:
            imagesBaseUri = "https://bafybeigk5aakyzyxe36lczjtrqontbusk4artnezzzoe5b4ymclgsz7fwe.ipfs.nftstorage.link/{token}.png"
            break;
        case 2:
            imagesBaseUri = "https://ipfs.io/ipfs/QmchtKYDsS85rHSrPF2TQqxnqZo3jNrV1TSAEdCtX7T4Hn/{token}.png"
            break;
        case 3:
            imagesBaseUri = "https://bafybeiglssbennap6cz4jxc2nhsbymxbd635p4zgt7kixou54dtgeor7ca.ipfs.nftstorage.link/{token}.png"
            break;
        case 4:
            imagesBaseUri = "https://bafybeiabvowgvjjn77xiiz5rs7gsrchv52oonhobdkcsnogb4gfds4cvxy.ipfs.nftstorage.link/{token}.png"
            break
        default:
            imagesBaseUri = "https://bafybeie2sjqpuni5vwd6szlyzmpx3iqqgogstwhokys74il44ja6jijq6q.ipfs.nftstorage.link/{token}.png"
            break;
    }

    let content = <>
        <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            px={4}
            maxW={"6xl"}
        >
            <Stat bg={useColorModeValue(
                "rgba(247, 250, 252, 0.5)",
                "rgba(23, 25, 35, 0.5)"
            )}
                rounded={"xl"}
                boxShadow={"md"}
                p={4}>
                <StatLabel>Address</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{account}</StatNumber>
            </Stat>

            <Stat bg={useColorModeValue(
                "rgba(247, 250, 252, 0.5)",
                "rgba(23, 25, 35, 0.5)"
            )}
                rounded={"xl"}
                boxShadow={"md"}
                p={4}>
                <StatLabel>Owned NFTs</StatLabel>
                <StatNumber fontSize={{ base: 'sm', md: 'md' }}>{tokens.length}</StatNumber>
            </Stat>
        </SimpleGrid>

        <SimpleGrid
            columns={{ base: 2, md: 4 }}
            spacing={{ base: 4, md: 8 }}
            my={{ base: 4, md: 8 }}
            mx={"auto"}
            maxW={"4xl"}
        >
            {tokens.map((token, i) => (
                <Link key={`${collectionOption}_${i}`} href={imagesBaseUri.replace("{token}", `${token}`)} isExternal>
                    <NFTItemView
                        name={`#${token}`}
                        image={imagesBaseUri.replace("{token}", `${token}`)}
                        selected={false}
                    />
                </Link>
            ))}
        </SimpleGrid>
    </>

    let emptyView = <>
        <Center mt={8}>
            <Text maxW={'2xl'}>You do not own any NFTs</Text>
        </Center>
    </>

    let connectWallet = <>
        <Container>
            <Center mt={8}>
                <Text maxW={'2xl'}>Connect Wallet to see your NFTs</Text>
            </Center>
            <Center mt={8}>
                <Button size={{ base: 'sm', sm: 'sm', md: 'md' }} onClick={web3Service.toggleConnect}>
                    {"Connect Wallet"}
                </Button>
            </Center>
        </Container>
    </>

    let picker = <>
        <Select variant={'filled'} mt={4} value={collectionOption} onChange={(option) => {
            setCollectionOption(Number(option.target.value))
        }}>
            <option value={0}>AI Experiments</option>
            <option value={1}>AI Labs</option>
            <option value={2}>Dr Dao</option>
            <option value={3}>Dr Dao X Mutants</option>
            <option value={4}>Ultimate Mutants</option>
        </Select></>

    return (
        <>
            <Box
                position={"fixed"}
                backgroundImage={`url(${BackgroundImage})`}
                backgroundSize="cover"
                width={'100%'}
                height={'100%'}
                opacity={0.5}
                zIndex={-3}
            />

            <Center my={8}>
                <Box>
                    {account ? picker : undefined}
                    {account ? (tokens.length > 0 ? content : emptyView) : connectWallet}
                </Box>
            </Center>
        </>
    );
};

export default GalleryView;
